import React from "react";
import { Link } from "react-router-dom";

export default function AdhanHeader() {
  return (
    <div className="flex items-center justify-between px-2 py-4 fixed w-full bg-blue-50">
      <div>
        <a href="https://apps.apple.com/us/app/adhan-prayer-timings/id6475295378">
          <img
            className="w-12 h-12 rounded-lg"
            src="/asset/adhan/logo/adhan_logo.svg"
            alt="Adhan Logo"
          />
        </a>
      </div>
      <div>
        <Link className="mr-4 text-blue-400 hover:text-blue-800" to="/adhan">
          Home
        </Link>
        <Link
          className="mr-4 text-blue-400 hover:text-blue-800"
          to="/adhan/privacy"
        >
          Privacy
        </Link>
        <Link
          className="mr-4 text-blue-400 hover:text-blue-800"
          to="/adhan/terms"
        >
          Terms
        </Link>
      </div>
    </div>
  );
}
